<div [formGroup]="form">
  <div class="card mt-3">
    <div class="card-header">
      <a id="TargetAusweispapiere"></a>
      <h3>
        <i class="icon-ausweispapiere"></i>
        <span *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Ausweispapiere</span>
        <span *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n="@@Unterlagen">Unterlagen</span>
        <span class="float_right" *ngIf="appConfig.isAssistantAvailable">
          <button type="button" class="btn btn-primary btn-assistent mb-1 me-1" (click)="enableAssistant()"
                  style="width: 170px; background-color: #367297">
            <i class="icon-assistant" style="font-size: 20px; vertical-align: text-bottom"></i>
            <span i18n>Assistent starten</span>
          </button>
        </span>
      </h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header card-header-detail" *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Ausweispapiere</div>
            <div class="card-header card-header-detail" *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>
              Ausweispapiere und Reiseunterlagen
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.pass.passArt" i18n [class.mandatory]="isMandatory('passArt')">Art des Reisedokuments:</label>
                    <select class="form-select form-select-sm"
                            id="antragsteller.pass.passArt"
                            [class.is-invalid]="errorClassRequired(form.controls['passArt'])"
                            formControlName="passArt"
                            [ngbPopover]="popover_antragsteller_pass_passArt"
                            appSaveLastFocussed
                    >
                      <option value="" selected></option>
                      <option *ngFor="let listItem of reisedokumentListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                    </select>
                    <ng-template #popover_antragsteller_pass_passArt>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte wählen Sie hier das Reisedokument des/der Antragstellenden aus, das zur Antragstellung vorgelegt wird.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.pass.passnummer" i18n [class.mandatory]="isMandatory('passNummer')">Nummer des Reisedokuments:</label>
                    <input id="antragsteller.pass.passnummer"
                           type="text" appToUpperCase [attr.maxlength]="getMaxLength('passNummer')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['passNummer'])"
                           formControlName="passNummer"
                           [ngbPopover]="popover_antragsteller_pass_passnummer"
                           appSaveLastFocussed
                    >
                    <ng-template #popover_antragsteller_pass_passnummer>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span
                          i18n>Bitte tragen Sie hier die Nummer des Reisedokuments des/der Antragstellenden ein (wie im Reisedokument angegeben).</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>

                <div class="col-md-4" *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'">
                  <div class="mb-3">
                    <label for="antragsteller.nationaleIdentNr" i18n [class.mandatory]="isMandatory('nationaleIdentNr')">
                      Ggf. nationale Identitätsnummer:</label>
                    <input id="antragsteller.nationaleIdentNr"
                           type="text" appToUpperCase [attr.maxlength]="getMaxLength('nationaleIdentNr')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['nationaleIdentNr'])"
                           formControlName="nationaleIdentNr"
                           [ngbPopover]="popover_antragsteller_nationaleIdentNr"
                           appSaveLastFocussed
                    >
                    <ng-template #popover_antragsteller_nationaleIdentNr>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier, sofern vorhanden, die nationale Identitätsnummer des/der Antragstellenden ein (wie im Reisedokument angegeben).</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.pass.gueltigVon" i18n [class.mandatory]="isMandatory('passAusstellungsdatum')"
                    >Ausstellungsdatum (TT.MM.JJJJ):</label>
                    <div class="input-group" *ngIf="presentationModeEnum.DEFAULT === appConfig.presentationMode">
                      <input angular-mydatepicker
                             id="antragsteller.pass.gueltigVon"
                             #passAusstellungsdatumDp="angular-mydatepicker"
                             [options]="datepickerOptions"
                             class="form-control form-control-sm w-50"
                             type="text"
                             [class.is-invalid]="errorClassRequired(form.controls['passAusstellungsdatum'])"
                             appDynamicDateMaxLength
                             formControlName="passAusstellungsdatum"
                             (inputFieldChanged)="onDatePickerInputFieldChanged('passAusstellungsdatum', $event)"
                             (blur)="onDatePickerBlur('passAusstellungsdatum')"
                             [ngbPopover]="popover_antragsteller_pass_gueltigVon"
                             appSaveLastFocussed
                      />
                      <ng-template #popover_antragsteller_pass_gueltigVon>
                        <app-assistant (assistantDisabled)="disableAssistant()">
                          <span i18n>Bitte tragen Sie hier das Ausstellungsdatum des Reisedokuments des/der Antragstellenden ein (wie im Reisedokument angegeben).</span>
                        </app-assistant>
                      </ng-template>
                      <span class="input-group-text date-picker" (click)="passAusstellungsdatumDp.toggleCalendar()"><i
                        class="icon-calendar"></i></span>
                    </div>
                    <div class="input-group" *ngIf="presentationModeEnum.AP2 === appConfig.presentationMode">
                      <input type="text"
                             class="form-control form-control-sm w-50"
                             value="{{dateFormatter.getFormattedDatePickerValue(form.value.passAusstellungsdatum)}}"
                             disabled
                      />
                      <span class="input-group-text date-picker"><i class="icon-calendar"></i></span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.pass.gueltigBis" i18n="@@gultig-bis-tt-mm-jjjj" [class.mandatory]="isMandatory('passGueltigbis')">Gültig
                      bis (TT.MM.JJJJ):</label>
                    <div class="input-group" *ngIf="presentationModeEnum.DEFAULT === appConfig.presentationMode">
                      <input angular-mydatepicker
                             id="antragsteller.pass.gueltigBis"
                             #passGueltigbisDp="angular-mydatepicker"
                             [options]="datepickerOptions"
                             class="form-control form-control-sm w-50"
                             type="text"
                             [class.is-invalid]="errorClassRequired(form.controls['passGueltigbis'])"
                             appDynamicDateMaxLength
                             formControlName="passGueltigbis"
                             (inputFieldChanged)="onDatePickerInputFieldChanged('passGueltigbis', $event)"
                             (blur)="onDatePickerBlur('passGueltigbis')"
                             [ngbPopover]="popover_antragsteller_pass_gueltigBis"
                             appSaveLastFocussed
                      />
                      <ng-template #popover_antragsteller_pass_gueltigBis>
                        <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                       (assistantDisabled)="disableAssistant()">
                          <span i18n>Bitte tragen Sie hier das Gültigkeitsdatum des Reisedokuments des/der Antragstellenden ein (wie im Reisedokument angegeben). Das Reisedokument sollte mindestens noch für die Dauer des Einreisevisums (3 Monate ab gewünschtem Einreisedatum) gültig sein.</span>
                        </app-assistant>
                        <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                       (assistantDisabled)="disableAssistant()">
                          <span i18n>Bitte tragen Sie hier das Gültigkeitsdatum des Reisedokuments des/der Antragstellenden ein (wie im Reisedokument angegeben).</span>
                        </app-assistant>
                      </ng-template>
                      <span class="input-group-text date-picker" (click)="passGueltigbisDp.toggleCalendar()"><i class="icon-calendar"></i></span>
                    </div>
                    <div class="input-group" *ngIf="presentationModeEnum.AP2 === appConfig.presentationMode">
                      <input type="text"
                             class="form-control form-control-sm w-50"
                             value="{{dateFormatter.getFormattedDatePickerValue(form.value.passGueltigbis)}}"
                             disabled
                      />
                      <span class="input-group-text date-picker"><i class="icon-calendar"></i></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.pass.ausstellenderStaat" i18n [class.mandatory]="isMandatory('passAusstellerstaat')"
                    >Ausstellender Staat:</label>
                    <select class="form-select form-select-sm"
                            id="antragsteller.pass.ausstellenderStaat"
                            [class.is-invalid]="errorClassRequired(form.controls['passAusstellerstaat'])"
                            formControlName="passAusstellerstaat"
                            [ngbPopover]="popover_antragsteller_pass_ausstellenderStaat"
                            appSaveLastFocussed
                    >
                      <option value=""></option>
                      <option *ngFor="let listItem of passaustellenderstaatListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                    </select>
                    <ng-template #popover_antragsteller_pass_ausstellenderStaat>
                      <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Wählen Sie hier bitte aus, welcher Staat das Reisedokument des/der Antragstellenden ausgestellt hat (siehe Angabe im Reisedokument).</span>
                      </app-assistant>
                      <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier den passausstellenden Staat des Reisedokuments des/der Antragstellenden ein (wie im Reisedokument angegeben).</span>
                      </app-assistant>
                    </ng-template>

                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.pass.ausgestelltVon" i18n [class.mandatory]="isMandatory('passAusgestelltvon')">Ausgestellt von:</label>
                    <input id="antragsteller.pass.ausgestelltVon"
                           type="text" appToUpperCase [attr.maxlength]="getMaxLength('passAusgestelltvon')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['passAusgestelltvon'])"
                           formControlName="passAusgestelltvon"
                           [ngbPopover]="popover_antragsteller_pass_ausgestelltVon"
                           appSaveLastFocussed
                    >
                    <ng-template #popover_antragsteller_pass_ausgestelltVon>
                      <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier ein, welche Behörde das Reisedokument des/der Antragstellenden ausgestellt hat (siehe Angabe im Reisedokument).</span>
                      </app-assistant>
                      <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier die passausstellende Behörde des Reisedokuments des/der Antragstellenden ein (wie im Reisedokument angegeben).</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <app-biometrie-kurzfristiger-aufenthalt *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                              formControlName="biometrie"
      >
      </app-biometrie-kurzfristiger-aufenthalt>

    </div>
  </div>
</div>
